
import React, { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import BulletinWrapper from './BulletinWrapper';
import { useIsMobile } from '@/hooks/use-mobile';

interface BulletinCardWrapperProps {
  isSelected: boolean;
  onImageClick: (e: React.MouseEvent) => void;
  onTouchStart: () => void;
  onTouchEnd: (e: React.TouchEvent) => void;
  children: React.ReactNode;
  isAdmin?: boolean;
  isPremium?: boolean;
}

const BulletinCardWrapper = ({
  isSelected,
  onImageClick,
  onTouchStart,
  onTouchEnd,
  children,
  isAdmin,
  isPremium,
}: BulletinCardWrapperProps) => {
  const isMobile = useIsMobile();
  const [isMounted, setIsMounted] = useState(false);
  
  console.log(`[BulletinCardWrapper] Render - isSelected: ${isSelected}, isMobile: ${isMobile}`);
  
  // Ensure the component is fully mounted before animations
  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  return (
    <BulletinWrapper
      isSelected={isSelected}
      onImageClick={onImageClick}
      onHoverStart={isMobile ? undefined : () => {}}
      onHoverEnd={isMobile ? undefined : () => {}}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      aria-label={`Bulletin ${isSelected ? 'in fullscreen mode' : ''}`}
      role="article"
      isAdmin={isAdmin}
      isPremium={isPremium}
    >
      <div 
        className={cn(
          "relative w-full h-full flex items-center justify-center cursor-pointer overflow-hidden transition-opacity duration-300",
          !isSelected && "w-full h-full"
        )}
        style={{
          position: 'relative',
          overflow: 'hidden',
          opacity: isMounted ? 1 : 0
        }}
      >
        {children}
      </div>
    </BulletinWrapper>
  );
};

export default BulletinCardWrapper;
